export const textStyle = "color: #00BCD4; font-weight: bold;";
